import React from 'react'

export default function Stars ({stars, overview}) {
  let starCount = stars
  if (starCount > 5) {
    starCount = 5
  } else if (starCount < 1) {
    starCount = 1
  }
  let starRow = []
  for (let i = 1; i <= starCount; i++) {
    starRow.push(
      <i className='fas fa-star colored' key={`tmfilledstar${i}`}></i>
    )
  }
  for (let i = 0; i < 5 - starCount; i++) {
    starRow.push(
      <i className='fas fa-star' key={`tmstar${i}`}></i>
    )
  }
  
  return (
    <div className={overview ? 'Stars' : 'stars'}>
      {starRow}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/Stars.js